//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import { CheckIcon, ChevronRightIcon } from "@chakra-ui/icons";
import {
  Alert,
  AlertDescription,
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  AlertIcon,
  AlertTitle,
  Badge,
  Box,
  Button,
  Checkbox,
  CheckboxGroup,
  Flex,
  HStack,
  Icon,
  Stack,
  Text,
  useBreakpointValue,
  useDisclosure,
} from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import Pluralize from "pluralize";
import React from "react";
import { BsCircleHalf, BsFillCheckCircleFill } from "react-icons/bs";
import { FaRegStickyNote } from "react-icons/fa";
import { GrNote, GrTest } from "react-icons/gr";
import { ISubjectStore, ITutorSubject } from "../stores";

const defaultContent = {
  title: "Inactive",
  subtitle: "Subjects may have been suspended",
  buttonText: "",
  canDelete: false,
  color: "red.500",
};

const jobDefaultContent = {
  title: "Add the required subjects",
  subtitle:
    "In order to qualify for this job, you must add the following subjects to your profile",
  buttonText: "",
  canDelete: "false",
  color: "red.500",
};

const subjectCardContent = {
  active: {
    title: "Approved",
    subtitle: "Your active subjects. Add more subjects, to get more students.",
    buttonText: "",
    color: "green.500",
  },
  pending: {
    title: "In-review",
    subtitle: "Subjects awaiting approval",
    buttonText: "",
    color: "orange.500",
  },
  denied: {
    title: "Denied",
    subtitle: "Subjects denied or not approved",
    buttonText: "Try again",
    color: "red.500",
  },
  "in-progress": {
    title: "In-progress",
    subtitle: "Finish these subjects for review",
    buttonText: "Finish up",
    color: "teal.500",
  },
  "not-started": {
    title: "Not started",
    subtitle: "Subjects you've not attempted",
    buttonText: "Take test",
    color: "gray.500",
  },
};

export const GenericSubjectCardGroup: React.FC<{
  store: ISubjectStore;
  status: string;
  subjects: any;
  onEdit: (subject: ITutorSubject) => void;
  onTakeTest: (subject: ITutorSubject) => void;
  onDeleteSubjects: (subjects: ITutorSubject[]) => Promise<void>;
  canEditSubject?: boolean;
}> = observer(
  ({
    store,
    status,
    subjects,
    onDeleteSubjects,
    onEdit,
    onTakeTest,
    canEditSubject = true,
  }) => {
    const content = jobDefaultContent;
    const [selected, setSelected] = React.useState(false);

    return (
      <Box mt={-4}>
        <Stack spacing={5} id="subject-card-group">
          <Alert status="error">
            <AlertIcon />
            <AlertTitle lineHeight={"short"}>
              Your entry wasn't sent because you don't have the required{" "}
              {Pluralize("subject", subjects.length, false)} for this job.
            </AlertTitle>
          </Alert>
          <Stack>
            <Text fontWeight="bold" fontSize="xl">
              {content.title}
            </Text>
            <Text fontSize="md" color="gray.600">
              {content.subtitle}
            </Text>
          </Stack>

          <Stack spacing={4}>
            {subjects.map((subject) => {
              return (
                <SubjectCard
                  key={subject.name}
                  selected={selected}
                  status={subject.status}
                  subject={subject}
                  isTested={store.shouldTakeTest(subject)}
                  // daysLeftToRetry={subject.daysLeftToRetry}
                  withinTimeWindow={subject.withinTimeWindow}
                  totalAttempts={subject.totalAttempts}
                  firstTestTime={subject.firstTestTime}
                  onEdit={() => onEdit(subject)}
                  onTakeTest={() => onTakeTest(subject)}
                  {...{
                    ...content,
                    buttonText:
                      subject.status === "not-started"
                        ? "Take Test"
                        : subject.status === "active"
                        ? "Edit"
                        : content.buttonText,
                  }}
                  canEditSubject={canEditSubject}
                />
              );
            })}
          </Stack>
        </Stack>
      </Box>
    );
  }
);

export const SubjectCardGroup: React.FC<{
  store: ISubjectStore;
  status: string;
  subjects: any;
  onEdit: (subject: ITutorSubject) => void;
  onTakeTest: (subject: ITutorSubject) => void;
  onDeleteSubjects: (subjects: ITutorSubject[]) => Promise<void>;
  canEditSubject?: boolean;
  canDeleteSubject?: boolean;
}> = observer(
  ({
    store,
    status,
    subjects,
    onDeleteSubjects,
    onEdit,
    onTakeTest,
    canEditSubject = true,
    canDeleteSubject,
  }) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const cancelRef = React.useRef();

    const content = subjectCardContent[status] || defaultContent;
    const deletedAbleStatus = ["in-progress", "not-started"];
    const [selected, setSelected] = React.useState(false);
    const [selectedSubjects, setSelectedSubjects] = React.useState([]);

    const handleDelete = async () => {
      const deletedSubjects = subjects.filter((subject) =>
        selectedSubjects.includes(subject.name)
      );
      await onDeleteSubjects(deletedSubjects);
      onClose();
      setSelected(false);
      setSelectedSubjects([]);
    };
    return (
      <Box>
        <Stack spacing={5} id="subject-card-group">
          <HStack justifyContent="space-between">
            <Box>
              <Text fontWeight="bold" fontSize="xl">
                {content.title}
              </Text>
              <Text fontSize="sm" color="gray.600">
                {content.subtitle}
              </Text>
            </Box>
            {deletedAbleStatus.includes(status) && canDeleteSubject && (
              <Checkbox
                size="lg"
                alignSelf="flex-end"
                isChecked={selected}
                onChange={({ target }) => {
                  setSelected(target.checked);
                  if (!target.checked) setSelectedSubjects([]);
                }}
                borderColor="neutral.500"
                value="delete"
              >
                <Text fontSize="sm" color="gray.600">
                  Select
                </Text>
              </Checkbox>
            )}
          </HStack>

          <Box
            borderWidth="2xs"
            borderColor="neutral.500"
            rounded="md"
            overflow="hidden"
          >
            {subjects.map((subject) => {
              return (
                <CheckboxGroup
                  value={selectedSubjects}
                  onChange={(values) => setSelectedSubjects(values)}
                >
                  <SubjectCard
                    key={subject.name}
                    selected={selected}
                    status={status}
                    subject={subject}
                    isTested={store.shouldTakeTest(subject)}
                    // daysLeftToRetry={subject.daysLeftToRetry}
                    withinTimeWindow={subject.withinTimeWindow}
                    totalAttempts={subject.totalAttempts}
                    firstTestTime={subject.firstTestTime}
                    onEdit={() => onEdit(subject)}
                    onTakeTest={() => onTakeTest(subject)}
                    {...content}
                    canEditSubject={canEditSubject}
                  />
                </CheckboxGroup>
              );
            })}
          </Box>

          {selected ? (
            <Flex
              rounded="md"
              borderWidth="2xs"
              borderColor="neutral.300"
              px={[5, 6]}
              py={4}
              bg="neutral.100"
            >
              <HStack spacing={4} width="100%">
                <Button
                  isFullWidth
                  bg="white"
                  onClick={() => {
                    setSelected(false);
                    setSelectedSubjects([]);
                  }}
                >
                  Cancel
                </Button>
                <Button
                  isFullWidth
                  colorScheme="red"
                  isDisabled={!selectedSubjects.length}
                  onClick={onOpen}
                >
                  Delete
                </Button>
              </HStack>
            </Flex>
          ) : null}
        </Stack>

        <AlertDialog
          isOpen={isOpen}
          leastDestructiveRef={cancelRef}
          onClose={onClose}
        >
          <AlertDialogOverlay>
            <AlertDialogContent mx={6}>
              <AlertDialogHeader fontSize="lg" fontWeight="bold">
                Confirm delete
              </AlertDialogHeader>

              <AlertDialogBody>
                <Stack spacing={4}>
                  <Text>
                    Are you sure you want to delete the following subjects:
                  </Text>

                  <Stack>
                    {selectedSubjects.map((subject, index) => (
                      <Text fontWeight="medium">
                        {index + 1}. {subject}
                      </Text>
                    ))}
                  </Stack>
                </Stack>
              </AlertDialogBody>

              <AlertDialogFooter>
                <Button ref={cancelRef} onClick={onClose}>
                  No, go back
                </Button>
                <Button
                  colorScheme="red"
                  onClick={handleDelete}
                  ml={3}
                  isLoading={store.loading}
                >
                  Yes, delete
                </Button>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialogOverlay>
        </AlertDialog>
      </Box>
    );
  }
);

const SubjectCard: React.FC<{
  status: string;
  subject: any;
  selected: boolean;
  buttonText?: string;
  daysLeftToRetry?: number;
  onEdit: () => void;
  onTakeTest: () => void;
  isTested?: boolean;
  totalAttempts?: number;
  firstTestTime?: string;
  withinTimeWindow: number;
  canEditSubject?: boolean;
}> = observer(
  ({
    status,
    subject,
    daysLeftToRetry,
    onEdit,
    onTakeTest,
    selected,
    isTested,
    totalAttempts,
    firstTestTime,
    buttonText,
    withinTimeWindow,
    canEditSubject = true,
  }) => {
    const canRetakeDeniedSubject = withinTimeWindow && totalAttempts == 2;
    const canAttemptSubject = withinTimeWindow && totalAttempts < 3;
    const disableButton =
      status === "denied" && firstTestTime ? !canAttemptSubject : false;
    const editStatuses = ["active", "pending", "in-progress"];
    const deleteableStatus = ["not-started", "in-progress"];

    let editable = canEditSubject;
    if (status === "denied") {
      editable = true;
    }
    if (status === "not-started") {
      editable = isTested ? true : canEditSubject;
    }

    const handleButtonClick = () => {
      if (status === "denied" && editable) {
        onTakeTest();
      }

      if (status === "not-started") {
        if (isTested) onTakeTest();
        if (!isTested) onEdit();
      }

      if (editStatuses.includes(status)) onEdit();
    };
    return (
      <Flex
        minH={12}
        pr={3}
        pl={[5, 6]}
        py={4}
        id="subject-card"
        align="center"
        justify="center"
        bg={disableButton ? "neutral.300" : "inherit"}
        opacity={disableButton ? 0.7 : 1}
        _notLast={{ borderBottomWidth: "2xs" }}
        _hover={{ bg: disableButton ? "neutral.300" : "gray.50" }}
        {...(!deleteableStatus.includes(status) && {
          onClick: disableButton ? undefined : handleButtonClick,
          cursor: "pointer",
        })}
      >
        <HStack
          role="group"
          width="100%"
          spacing={4}
          justifyContent="space-between"
        >
          <HStack spacing={3}>
            {selected && (
              <Checkbox
                defaultChecked={selected}
                borderColor="neutral.500"
                value={subject.name}
                size="lg"
              />
            )}
            <Box lineHeight="short">
              {status === "denied" && canRetakeDeniedSubject && (
                <Badge colorScheme="orange" size="sm" fontSize="8px">
                  Final attempt
                </Badge>
              )}
              {/* {status === "denied" && !disableButton && (
                <Badge colorScheme="red" size="sm" fontSize="8px">
                  Retry
                </Badge>
              )} */}
              <Text fontWeight="medium" fontSize={{ base: "sm", md: "md" }}>
                {subject.name}
              </Text>
              <Text fontSize="xs" color="gray.600">
                {subject.category}
              </Text>
            </Box>
          </HStack>

          <HStack
            onClick={handleButtonClick}
            spacing={0}
            fontWeight="semibold"
            display={selected ? "none" : "flex"}
          >
            {status === "active" && (
              <HStack>
                <HStack>
                  <Icon color="green.600" as={BsFillCheckCircleFill} />
                  <Text fontSize={{ base: "sm", md: "md" }}>Active</Text>
                </HStack>
                <ChevronRightIcon
                  color={
                    ["not-started", "in-progress"].includes(status)
                      ? "blue.500"
                      : "inherit"
                  }
                  _groupHover={{
                    color: disableButton ? "inherit" : "blue.500",
                  }}
                  fontSize={{ base: "2xl", md: "3xl" }}
                />
              </HStack>
            )}

            {status === "pending" && (
              <HStack>
                <HStack>
                  <Icon color="green.600" as={BsCircleHalf} />
                  <Text fontSize={{ base: "sm", md: "md" }}>Pending</Text>
                </HStack>
                <ChevronRightIcon
                  color={
                    ["not-started", "in-progress"].includes(status)
                      ? "blue.500"
                      : "inherit"
                  }
                  _groupHover={{
                    color: disableButton ? "inherit" : "blue.500",
                  }}
                  fontSize={{ base: "2xl", md: "3xl" }}
                />
              </HStack>
            )}

            {status === "in-progress" && (
              <Button
                rightIcon={
                  <ChevronRightIcon fontSize={{ base: "2xl", md: "3xl" }} />
                }
                colorScheme="blue"
                variant="link"
                iconSpacing={1}
                size={useBreakpointValue({ base: "sm", md: "md" })}
              >
                Finish up
              </Button>
            )}

            {status === "not-started" && !disableButton && (
              <Button
                rightIcon={
                  <ChevronRightIcon fontSize={{ base: "2xl", md: "3xl" }} />
                }
                colorScheme="blue"
                variant="link"
                iconSpacing={1}
                size={useBreakpointValue({ base: "sm", md: "md" })}
              >
                {isTested ? `${buttonText}` : "Finish up"}
              </Button>
            )}

            {/* {status !== "not-started" && editable && !disableButton &&
              <Button rightIcon={<ChevronRightIcon fontSize={{ base: "2xl", md: "3xl" }} />}
                colorScheme="blue"
                variant="link"
                disabled={disableButton}
                iconSpacing={1}
                size={useBreakpointValue({ base: "sm", md: "md" })}
              >
                {buttonText}
              </Button>
            } */}
          </HStack>
        </HStack>
      </Flex>
    );
  }
);
